import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, withTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import "./tree.css";
import Paper from "@material-ui/core/Paper";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Typography from "@material-ui/core/Typography";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import { taxServiceClient } from "../../AxiosClient";
import InfoIcon from "@material-ui/icons/Info";
import Snackbar from "@material-ui/core/Snackbar";
import Skeleton from "@material-ui/lab/Skeleton";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { SnackbarContent } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ClickAndDoubleClick from "./ClickAndDoubleClick";
import Badge from "@material-ui/core/Badge";

import ExpertModeratorItem from "./ExpertModeratorItem";
import { Trans, withTranslation } from "react-i18next";
import FilterableList from "../../administration/components/FilterableList.js";
import SvgIcon from "@material-ui/core/SvgIcon";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Alert, AlertTitle } from "@material-ui/lab";

const styles = (theme) => ({
  paper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    minWidth: 200,
    minHeight: 200,
  },
  activeNode: {
    color: theme.palette.secondary.main,
  },
  node: {
    cursor: "pointer",
    display: "flex",
    "& div": {
      marginLeft: "5px",
    },
  },
  root: {
    height: 250,
    flexGrow: 1,
  },
  popover: {
    root: {
      zIndex: 9999999999,
    },
  },
  container: {
    position: "relative",
    marginBottom: 10,
    marginLeft: 10,
    // width: '75%',
  },
  suggestionsContainerOpen: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  divider: {
    height: theme.spacing(2),
  },
  labelRoot: {
    display: "flex",
    alignItems: "bottom",
    padding: theme.spacing(0.5, 0),
    paddingRight: theme.spacing(1),
    userSelect: "none",
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: "inherit",
    flexGrow: 1,
    // marginBottom: theme.spacing(1)
  },
  treeContainer: {
    minWidth: 300,
    //  minHeight: 300,
    overflow: "auto",
  },
  "@global": {
    ".MuiTreeItem-root.Mui-selected,.MuiTreeItem-root.Mui-selected:focus": {
      backgroundColor: "transparent",
    },
    ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label,.MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label": {
      backgroundColor: "transparent",
    },
  },
  checkBox: {
    paddingBottom: "12px",
  },
  itemDisabled: {
    opacity: theme.palette.action.disabledOpacity,
  },
  tooltip: { zIndex: 10003 },
  userRoleIcon: {
    margin: 0,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: "flex",
  },
  treeRoot: {
    marginTop: theme.spacing(1),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogTitleWrapper: {
    marginRight: theme.spacing(4),
  },
});
const taxonomySVG =
  "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z";
const topicSVG =
  "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";
const teamSVG =
  "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z";
const userSVG =
  "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z";
const userOnlineSVG =
  "M13,17V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H5V15.5C5,13.57 8.13,12 12,12C15.87,12 19,13.57 19,15.5V17H13M12,3A3.5,3.5 0 0,1 15.5,6.5A3.5,3.5 0 0,1 12,10A3.5,3.5 0 0,1 8.5,6.5A3.5,3.5 0 0,1 12,3Z";
const userOfflineSVG =
  "M13.03 9.83L8.67 5.47C9.11 4.04 10.43 3 12 3C13.93 3 15.5 4.57 15.5 6.5C15.5 8.07 14.46 9.39 13.03 9.83M19 15.5C19 14.26 17.7 13.17 15.75 12.55L19 15.8V15.5M22 22H21.57L20.84 22.73L20.11 22H15C15 22.55 14.55 23 14 23H10C9.45 23 9 22.55 9 22H2V20H9C9 19.45 9.45 19 10 19H11V17H5V15.5C5 13.88 7.22 12.5 10.23 12.12L1.11 3L2.39 1.73L22 21.34V21.35L22.11 21.46L22 21.57V22M18.11 20L15.11 17H13V19H14C14.55 19 15 19.45 15 20H18.11Z";
const searchTree = "search";
const expertTree = "expert";
const reportsTree = "reports";
const checkBoxSVG =
  "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z";
const checkedBoxSVG =
  "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z";
const intermediateCheckBoxSVG =
  "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V7H17V17Z";
const workflowSVG =
  "M19 17V19H7V17S7 13 13 13 19 17 19 17M16 8A3 3 0 1 0 13 11A3 3 0 0 0 16 8M19.2 13.06A5.6 5.6 0 0 1 21 17V19H24V17S24 13.55 19.2 13.06M18 5A2.91 2.91 0 0 0 17.11 5.14A5 5 0 0 1 17.11 10.86A2.91 2.91 0 0 0 18 11A3 3 0 0 0 18 5M7.34 8.92L8.5 10.33L3.75 15.08L1 12.08L2.16 10.92L3.75 12.5L7.34 8.92";
const alertSVG = "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z";
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class TaxonomyTree extends Component {
  static propTypes = {
    onNodeSelected: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      treeData: {},
      forceUpdate: false,
      activeNode: [],
      suggestions: [],
      input: "",
      topicColourTheme: `${this.props.theme.palette.primary.dark}`,
      taxonomyColourTheme: `${this.props.theme.palette.primary.light}`,
      teamColourTheme: `${this.props.theme.palette.secondary.dark}`,
      disabledColourTheme: `${this.props.theme.palette.text.disabled}`,
      treeType: "",
      expertTreeUrl: "/taxonomy/expert",
      expertTreeData: {},
      reportsTreeUrl: "/taxonomy/reports",
      reportsTreeData: {},
      treeSelections: [],
      nodeLookup: [],
      expanded: [
        this.props.startWithExpanded
          ? this.props.startWithExpanded
          : this.props.taxonomyTree.id,
      ],
      showNoneSelected: false,
      loading: true,
      anchorEl: null,
      usersForPopover: [],
      teams: null,
      roledUsers: null,
      loadingPopover: false,
      taxonomyTree: null,
      page: 0,
      paginatedUsersForPopover: [],
      popoverNodeId: null,
      isReady: false,
      taxNodesTeamsCanSee: [],
      needToCheckIfTeamsCanSee: false,
      canSeeAllTopicSelections: true,
      beExpert:
        "M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z",
      forumModerator:
        "M20,17A2,2 0 0,0 22,15V4A2,2 0 0,0 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9A2,2 0 0,1 3.5,7H15M8,4A2,2 0 0,1 6,6A2,2 0 0,1 4,4A2,2 0 0,1 6,2A2,2 0 0,1 8,4Z",
    };
  }

  componentDidMount() {
    if (this.props.treeType === expertTree) {
      this.getExpertTree();
    } else if (this.props.treeType === reportsTree) {
      this.getReportsTree();
    } else {
      this.setState({ loading: false });
    }
    this.setState({
      treeType: this.props.treeType ? this.props.treeType : searchTree,
    });
    if (this.props.includeRoledUsers) {
      this.getTaxonomyUsers();
    }
    if (this.props.taxonomyTree) {
      this.sortTeamsArray();
    }
  }
  sortTeamsArray = () => {
    let teams = [];
    this.getTeams(teams, this.props.taxonomyTree);
    this.setState({ teams });
  };
  getTeams = (teamsArray, node) => {
    node &&
      node.children &&
      node.children.forEach((child) => {
        let taxArray = [];
        if (child.type === "team") {
          taxArray.push(node);
          this.getTaxnodes(taxArray, node.children);
          child.taxArray = taxArray;
          teamsArray.push(child);
        } else if (child.type === "taxonomy") {
          this.getTeams(teamsArray, child);
        }
      });
  };
  getTaxnodes = (nodes, children) => {
    children &&
      children.forEach((child) => {
        if (child.type === "taxonomy") {
          nodes.push(child);
        }
        child.children && this.getTaxnodes(nodes, child.children);
      });
  };
  getTaxonomyUsers = () => {
    taxServiceClient.get("/taxonomy/taxonomyUserRoleCount").then((res) => {
      this.setState({ roledUsers: res.data });
    });
  };
  getExpertTree = () => {
    let url = this.state.expertTreeUrl;
    taxServiceClient
      .get(url)
      .then((res) => {
        this.setState({ expertTreeData: res.data, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
        alert("error getting expert tree");
      });
  };
  getReportsTree = () => {
    let url = this.state.reportsTreeUrl;
    taxServiceClient
      .get(url)
      .then((res) => {
        this.setState({ reportsTreeData: res.data, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
        alert("error getting reports tree");
      });
  };
  addUniqueTax = (array, arrayToBeAdded) => {
    arrayToBeAdded.forEach((node) => {
      if (!array.find((item) => item.id === node.id)) {
        array.push(node);
      }
    });
  };
  rebuildExpanded = (idsToExpand) => {
    let ids = [];
    idsToExpand.forEach((id) => {
      let lookup = this.props.taxonomyNodeLookup.filter((t) => t.id == id);
      ids =
        lookup && ids.length > 0
          ? ids.concat(lookup[0].parentList)
          : lookup[0].parentList;
    });
    let newArray = [...new Set(ids)];
    this.setState({ expanded: newArray });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      // !areObjectsEqual(prevProps.filter, this.props.filter) &&
      this.state.isReady === false &&
      this.props.teamLayoutEditMode === true &&
      this.props.portalLayout.teamPortals &&
      this.props.portalLayout.teamPortals.length > 0
    ) {
      // this.setState({ isReady: false, needToCheckIfTeamsCanSee: true });
      let teamIds = this.props.portalLayout.teamPortals.map(
        (item) => item.teamId
      );
      taxServiceClient
        .get("/taxonomy/sharedtaxonomynodes", { params: { teamIds } })
        .then((res) => {
          this.setState({
            needToCheckIfTeamsCanSee: true,
            taxNodesTeamsCanSee: res.data,
            isReady: true,
          });
        });
    }
    this.props.startWithExpanded &&
      this.props.startWithExpanded !== prevProps.startWithExpanded &&
      this.rebuildExpanded(this.props.startWithExpanded);
    if (
      (this.props.teamLayoutEditMode === false &&
        (prevState.treeType !== this.state.treeType ||
          !areObjectsEqual(prevProps.filter, this.props.filter) ||
          prevProps.teamLayoutEditMode === true)) ||
      (this.props.teamLayoutEditMode === true &&
        this.state.isReady === true &&
        prevState.isReady === false)
    ) {
      // let treeData = this.state.treeType === expertTree ? this.state.expertTreeData : this.props.taxonomyTree
      let lookup = this.props.taxonomyNodeLookup;

      //if we don't have a filter set we need to select everything
      let filteredFilter = this.props.filter
        ? this.props.filter.filter(
            (t) =>
              lookup.filter((l) => l.id === t.id && l.type === t.type).length >
                0 &&
              (this.props.teamLayoutEditMode === false ||
                (this.state.needToCheckIfTeamsCanSee === true &&
                  this.teamsCanSeeNode(t)))
          )
        : [];
      let active = filteredFilter
        ? //if we are being passed a single node from say the KnowledgeSource selector we need to
          //match on the actual topicId and not the node id. the object passed has an id, type
          //and name instead of there being a node object
          filteredFilter.length > 0
          ? filteredFilter.map(
              (ele) =>
                ele.hasOwnProperty("object")
                  ? ele
                  : lookup.filter((el) => {
                      return el.type === ele.type && el.id === ele.id && (ele.type === "taxonomy" || JSON.stringify(ele.parentList) === JSON.stringify(el.parentList));
                    })[0]
            ).filter(item => item !== undefined)
          : []
        : [];
      this.setState(
        {
          nodeLookup: lookup,
          activeNode: active,
        },
        () => {
          !this.props.filter &&
            // ? active.forEach((ele) => this.addToExpanded(ele))
            // :
            lookup
              .filter((ele) => ele.parentList.length === 0)
              .forEach((child) => this.addToExpanded(child));
          // : this.props.filter.length < this.props.taxonomyNodeLookup.length &&
          //     this.props.taxonomyNodeLookup
          //       .filter(ele => this.props.filter.filter(f => f.id === ele.id && f.type === ele.type).length > 0)
          //       .forEach(s => this.addToExpanded(s))
        }
      );
    }
  }

  handleToggle = (event, nodeIds) => {
    this.setState({ expanded: nodeIds });
  };
  pushChildren = (selections, children) => {
    children &&
      children.forEach((child) => {
        this.getSelectedNodePos(selections, child) === -1 &&
          selections.push(child);
        this.pushChildren(selections, child.children);
      });
  };
  unSelectChildren = (selections, children) => {
    children &&
      children.forEach((child) => {
        this.unSelectChildren(selections, child.children);
        let pos = this.getSelectedNodePos(this.state.activeNode, child);
        pos > -1 && selections.splice(pos, 1);
      });
  };
  pushParent = (selections, node) => {
    let reversed = node.parentList ? [...node.parentList] : [];
    reversed.reverse().forEach(
      function(parentId) {
        let parentNodes = this.state.nodeLookup.filter(
          (ele) => ele.id === parentId
        );
        if (parentNodes.length > 0) {
          let parentNode = parentNodes[0];
          if (this.getSelectedNodePos(selections, parentNode) === -1) {
            let canBePushed = true;
            let childrenToCheck = parentNode.children.filter(c => c.type !== "team" && (c.type !== "taxonomy" || (c.type === "taxonomy" && c.children.length > 0)))
            for (let i = 0; i < childrenToCheck.length; i++) {
              canBePushed =
                  this.getSelectedNodePos(selections, childrenToCheck[i]) >
                  -1;
              if (canBePushed === false) {
                break;
              }
            }
            if (canBePushed) {
              selections.push(parentNode);
            }
          }
          // if (canBePushed) {
          //   selections.push(parentNode)
          // }
        }
      }.bind(this)
    );
  };

  onClickNode = (node, event) => {
    let allowedSelection = true;
    if (this.props.allowedSelections) {
      if (this.props.allowedSelections.indexOf(node.type) === -1) {
        allowedSelection = false;
      }
    } else if (this.props.topicSelector && node.type !== "topic") {
      allowedSelection = false;
    }

    if (allowedSelection) {
      let newSelections = this.state.activeNode;
      let b4 = [...this.state.activeNode];
      let pos = this.getSelectedNodePos(newSelections, node);
      if (pos === -1) {
        //not selected
        if (this.props.multiSelect) {
          newSelections.push(node);
          this.pushChildren(newSelections, node.children);
          //find the parent and check whether all it's children are selected so we can push it
          this.pushParent(newSelections, node);
        } else {
          newSelections = [node];
        }
      } else {
        //already selected so unselect
        newSelections.splice(pos, 1);
        this.unSelectChildren(newSelections, node.children);
        if (this.props.multiSelect) {
          newSelections = newSelections.filter(
            (ele) => node.parentList.indexOf(ele.id) === -1
          );
        }
        // check we aren't removing everything because we can't distinguish between this
        // and having no filter to select the whole taxonomy
        // newSelections = this.state.activeNode.length === 0 ? b4 : newSelections
        if (newSelections.length === 0) {
          newSelections = b4;
          this.props.multiSelect && this.setState({ showNoneSelected: true });
        }
      }
      const newTreeSelections = newSelections.map((nodeEl) => nodeEl.id);

      this.setState({
        activeNode: newSelections,
        treeSelections: newTreeSelections,
      });
      this.props.onNodeSelected(
        this.props.multiSelect ? newSelections : newSelections[0]
      );
    }

    !this.props.multiSelect && this.setState({ input: "" });
  };

  onDoubleClickNode = (node, event) => {
    // Just select the node that has been double clicked unselect all others
    // unless they should be selected - all is selected below them
    let allowedSelection = true;
    if (this.props.allowedSelections) {
      if (this.props.allowedSelections.indexOf(node.type) === -1) {
        allowedSelection = false;
      }
    } else if (this.props.topicSelector && node.type !== "topic") {
      allowedSelection = false;
    }

    if (allowedSelection) {
      let newSelections = [];
      if (this.props.multiSelect) {
        newSelections.push(node);
        this.pushChildren(newSelections, node.children);
        //find the parent and check whether all it's children are selected so we can push it
        this.pushParent(newSelections, node);
      } else {
        newSelections = [node];
      }

      const newTreeSelections = newSelections.map((nodeEl) => nodeEl.id);

      this.setState({
        activeNode: newSelections,
        treeSelections: newTreeSelections,
      });
      this.props.onNodeSelected(
        this.props.multiSelect ? newSelections : newSelections[0]
      );
    }

    this.props.multiSelect !== true && this.setState({ input: "" });
  };
  getSelectedNodePos = (selections, node) => {
    let nodeParents = JSON.stringify(node.parentList);
    let pos = selections
      ? selections
          // .filter(s => (s.id === node.id && s.type === node.type && JSON.stringify(s.parentList) === JSON.stringify(node.parentList)) ||
          //   (node.parentList.length > 0 && s.type === "taxonomy" && s.id === node.parentList[node.parentList.length -1])
          // ).length > 0 ? 1 : -1
          .map((selectedNode) => {
            let selectedNodeParents = JSON.stringify(selectedNode.parentList);
            if (selectedNodeParents === nodeParents) {
              return selectedNode.type
                ? selectedNode.type + "-" + selectedNode.id
                : selectedNode.id;
            }
          })
          .indexOf(node.type + "-" + node.id)
      : -1;

    return pos;
  };
  isNodeSelected = (node) => {
    const matchesNode = (s) =>
      s.id === node.id &&
      s.type === node.type &&
      JSON.stringify(s.parentList) === JSON.stringify(node.parentList);
    return this.state.activeNode.length === this.props.taxonomyNodeLookup.length
      ? true
      : this.state.activeNode.some(matchesNode);
  };
  hasSelectedChild = (node) => {
    const matchesNode = (s) => s.parentList.indexOf(node.id) > -1;
    return this.state.activeNode.some(matchesNode);
  };
  isItemHidden = (node) => {
    if (this.props.showExpertStatus && !node.isUserExpert) {
      if (node.type === "topic") {
        return true;
      } else {
        let children = node.children.filter(
          (ele) => ele.type === "taxonomy" || ele.type === "topic"
        );
        if (children.length > 0) {
          return children.filter((ele) => !this.isItemHidden(ele)).length === 0;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  };
  renderSkeletons = () => {
    return (
      <>
        <Skeleton
          width={250}
          height={40}
          animation="wave"
          style={{ marginLeft: 15 }}
        />
        <Skeleton
          width={200}
          height={40}
          animation="wave"
          style={{ marginLeft: 40, marginTop: -10 }}
        />
        <Skeleton
          width={200}
          height={40}
          animation="wave"
          style={{ marginLeft: 40, marginTop: -10 }}
        />
        <Skeleton
          width={250}
          height={40}
          animation="wave"
          style={{ marginLeft: 15, marginTop: -10 }}
        />
        <Skeleton
          width={200}
          height={40}
          animation="wave"
          style={{ marginLeft: 40, marginTop: -10 }}
        />
        <Skeleton
          width={200}
          height={40}
          animation="wave"
          style={{ marginLeft: 40, marginTop: -10 }}
        />
        <Skeleton
          width={200}
          height={40}
          animation="wave"
          style={{ marginLeft: 40, marginTop: -10 }}
        />
        <Skeleton
          width={200}
          height={40}
          animation="wave"
          style={{ marginLeft: 40, marginTop: -10 }}
        />
        <Skeleton
          width={250}
          height={40}
          animation="wave"
          style={{ marginLeft: 15, marginTop: -10 }}
        />
        <Skeleton
          width={200}
          height={40}
          animation="wave"
          style={{ marginLeft: 40, marginTop: -10 }}
        />
      </>
    );
  };

  teamsCanSeeNode = (node) => {
    let search = [...this.state.taxNodesTeamsCanSee];
    // This is for the situation when a Layout shared with a team is being edited by a user with TEAM_LEADER role
    // We need to disable nodes that are not visible to the team eventhough they are to the TEAM_LEADER
    // The state object taxNodesTeamsCanSee contains a list of taxonomy nodes the team can see, we check
    // whether the node passed in exists in it OR whether any of the nodes in the list visible to the Team have this
    // node as a parent. If the node passed in is a topic we check whether its parent list contains any of the visible taxonomy nodes
    return Array.isArray(search)
      ? search.filter((t) => {
          let matchedNode = this.props.taxonomyNodeLookup.filter(
            (ele) => ele.id === t.taxonomyId && ele.type === "taxonomy"
          );
          let nodeParents =
            matchedNode.length > 0 ? matchedNode[0].parentList : [];
          return (
            t.taxonomyId === node.id ||
            (node.type === "taxonomy" &&
              nodeParents.length > 0 &&
              nodeParents.includes(node.id)) ||
            (node.type === "topic" &&
              node.parentList.length > 0 &&
              node.parentList.includes(t.taxonomyId))
          );
        }).length > 0
      : false;
  };

  canSeeTopicOrHasMoved = (node) => {
    if (node.type === "topic") {
      node.parentList.forEach((parent) => {});
    }
  };

  handlePopoverOpen = (event, node) => {
    this.setState({
      anchorEl: event.currentTarget,
      loadingPopover: false,
      popoverNodeId: node,
    });

    event.stopPropagation();
  };
  isUserOnline = (item) => {
    return item.online === true;
  };
  iconTooltip = (item) => {
    const { t } = this.props;
    return item.online === true ? t("global_online") : t("global_offline");
  };
  getExpertModeratorPrimaryInfo = (item) => {
    return (
      <>{item.firstName + " " + item.surname + " (" + item.userLogin + ")"}</>
    );
  };
  getExpertModeratorSecondaryInfo = (item) => {
    const { classes, theme, t } = this.props;
    const userName =
      item.firstName + " " + item.surname + " (" + item.userLogin + ")";
    return (
      <div style={{ display: "flex" }}>
        {item.userPermits &&
          Object.entries(item.userPermits.roles).map(([key, value]) => {
            return (
              <>
                {value === true &&
                  this.state.hasOwnProperty(key) && (
                    <Tooltip
                      title={
                        <Typography>
                          {key.toLowerCase() === "beexpert"
                            ? t("role_beExpert")
                            : key.toLowerCase() === "forummoderator"
                              ? t("role_forumModerator")
                              : ""}
                        </Typography>
                      }
                      classes={{ popper: classes.tooltip }}
                      enterDelay={300}
                    >
                      <SvgIcon classes={{ root: classes.userRoleIcon }}>
                        <path
                          d={this.state[key]}
                          fill={
                            this.state.teamColourTheme
                          }
                        />
                      </SvgIcon>
                    </Tooltip>
                  )}
              </>
            );
          })}
      </div>
    );
  };
  getExpertModeratorCollapsibleSection = (user) => {
    let nodeId = this.state.popoverNodeId;
    return <ExpertModeratorItem user={user} node={{ id: nodeId }} />;
  };
  userSelected = () => {};

  handlePopoverClose = (e) => {
    this.setState(
      { anchorEl: null, usersForPopover: [] },
      this.setState({ usersForPopover: [] })
    );
  };

  getBadgeForNode = (node) => {
    let value = 0;
    if (
      this.props.badgeValueField &&
      this.props.badges &&
      this.props.badges.length > 0
    ) {
      let badgeValueField = this.props.badgeValueField;
      let badges = this.props.badges.filter(
        (b) =>
          b.id === node.id &&
          b.type.toLowerCase().replaceAll("_node", "") === node.type
      );
      if (badges.length > 0) {
        value = this.props.badges
          .filter(
            (b) =>
              b.id === node.id &&
              b.type.toLowerCase().replaceAll("_node", "") === node.type
          )
          .map((b) => (b[badgeValueField] ? b[badgeValueField] : 0))
          .reduce((a, b) => a + b, 0);
      }
    }
    return value;
  };

  renderNode = (node) => {
    let isDisabled =
      this.props.teamLayoutEditMode &&
      this.state.needToCheckIfTeamsCanSee &&
      !this.teamsCanSeeNode(node);

    const { classes, t } = this.props;

    let childNodes =
      !node.hasOwnProperty("children") || !node.children
        ? []
        : node.children.filter(
            (ele) =>
              (this.props.hideTopics && ele.type === "taxonomy") ||
              (!this.props.hideTopics &&
                (ele.type === "taxonomy" || ele.type === "topic"))
          );
    if (
      this.isItemHidden(node) ||
      (node.type === "taxonomy" &&
        this.state.treeType === searchTree &&
        childNodes.length === 0)
    ) {
      return null;
    }
    // let isNodeSelected = this.getSelectedNodePos(this.state.activeNode,node) > -1
    let isNodeSelected = this.isNodeSelected(node);
    let isChildSelected =
      isNodeSelected === true ? false : this.hasSelectedChild(node);
    return (
      <>
        <Dialog
          open={
            this.state.anchorEl && node.id === this.state.popoverNodeId
              ? true
              : false
          }
          onClose={this.handlePopoverClose}
          scroll={"paper"}
          aria-labelledby=""
          aria-describedby=""
        >
          <DialogTitle>
            <div className={classes.dialogTitleWrapper}>
              Experts and Forum Moderators for {node.name}
            </div>
            <IconButton
              aria-label="Close"
              className={classes.closeButton}
              onClick={this.handlePopoverClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FilterableList
              dataurl={`/taxonomy/expertAndModerators/${node.id}`}
              name="onlineSort,firstName,surname,userLogin"
              getPrimaryInfo={this.getExpertModeratorPrimaryInfo}
              getSecondaryInfo={this.getExpertModeratorSecondaryInfo}
              iconColour={this.state.teamColourTheme}
              iconColourDisabled={this.state.disabledColourTheme}
              iconSVG={userOnlineSVG}
              onItemSelected={this.userSelected}
              isItemEnabled={this.isUserOnline}
              disabledIconSVG={userOfflineSVG}
              iconTooltip={this.iconTooltip}
              collapsibleSection={this.getExpertModeratorCollapsibleSection}
            />
          </DialogContent>
        </Dialog>

        <TreeItem
          nodeId={node.id}
          key={node.id}
          aria-selected={isNodeSelected}
          onKeyDown={(e) => {
            if ((e.key === "Enter" || e.key === " ") && !isDisabled) {
              e.stopPropagation();
              this.onClickNode(node, e);
            }
          }}
          label={
            <ClickAndDoubleClick
              onClick={(node, e) => !isDisabled && this.onClickNode(node, e)}
              onDoubleClick={(node, e) =>
                !isDisabled && this.onDoubleClickNode(node, e)
              }
              node={node}
              children={
                <>
                  {this.props.multiSelect === true &&
                    (!this.props.allowedSelections ||
                      (this.props.allowedSelections &&
                        this.props.allowedSelections.indexOf(node.type) >
                          -1)) && (
                      <div className={classes.labelRoot}>
                        <svg
                          height="24px"
                          width="24px"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <path
                            fill={
                              !isDisabled
                                ? isNodeSelected || isChildSelected
                                  ? `${
                                      this.props.theme.palette.secondary.light
                                    }`
                                  : `${this.props.theme.palette.primary.light}`
                                : "rgba(0, 0, 0, 0.26)"
                            }
                            d={
                              // !isDisabled ?
                              isNodeSelected
                                ? checkedBoxSVG
                                : isChildSelected
                                  ? intermediateCheckBoxSVG
                                  : checkBoxSVG
                              // : checkBoxSVG
                            }
                          />
                        </svg>
                      </div>
                    )}
                  <div className={classes.labelRoot}>
                    <Tooltip
                      title={
                        <Typography>
                          {t(this.props.badgeMessageKey)} {node.badge}
                        </Typography>
                      }
                      classes={{ popper: classes.tooltip }}
                    >
                      <Badge
                        // style={{ marginTop: 4 }}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        variant="dot"
                        color="secondary"
                        badgeContent={node.badge ? node.badge : 0}
                        // badgeContent={node.badge ? <ChatBubbleIcon color="secondary"/> : 0}
                      >
                        <svg height="24px" width="24px">
                          <path
                            fill={
                              node.type === "taxonomy"
                                ? this.state.taxonomyColourTheme
                                : this.state.topicColourTheme
                            }
                            d={
                              node.type === "taxonomy" ? taxonomySVG : topicSVG
                            }
                          />
                        </svg>
                      </Badge>
                    </Tooltip>
                  </div>
                  <div
                    className={classes.labelRoot}
                    style={{
                      width: "100%",
                      color: isDisabled && "rgba(0, 0, 0, 0.26)",
                    }}
                  >
                    <Typography className={classes.labelText}>
                      {node.name}
                    </Typography>
                  </div>
                  {node.type === "topic" &&
                    node.workflowActive &&
                    this.props.showWorkflow && (
                      <div className={classes.labelRoot}>
                        <Tooltip
                          title={
                            <Typography>
                              {t("workflow_active_tooltip")}
                            </Typography>
                          }
                          classes={{ popper: classes.tooltip }}
                        >
                          <svg height="24px" width="24px" viewBox="0 0 24 24">
                            <path d={workflowSVG} />
                          </svg>
                        </Tooltip>
                      </div>
                    )}
                  {node.type === "taxonomy" &&
                    this.props.includeRoledUsers && (
                      <>
                        <Badge
                          style={{ marginTop: 4 }}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                          variant="string"
                          color="secondary"
                          badgeContent={this.findModUsers(node.id)}
                        >
                          <InfoIcon
                            color="primary"
                            onClick={(e) => this.handlePopoverOpen(e, node.id)}
                          />
                        </Badge>
                      </>
                    )}
                </>
              }
            />
          }
        >
          {this.state.expanded.indexOf(node.id) > -1
            ? childNodes.map((child) => {
                return this.renderNode(child);
              })
            : childNodes.map((child) => {
                return <span />;
              })}
        </TreeItem>
      </>
    );
  };
  findModUsers = (id) => {
    let count =
      this.state.roledUsers &&
      this.state.roledUsers.filter((t) => t.taxonomyId === id).length > 0
        ? this.state.roledUsers
            .filter((t) => t.taxonomyId === id)
            .map((t) => t.userRoleCount)
        : 0;
    return count;
  };
  addToExpanded = (node) => {
    let newExpanded = this.state.expanded;
    newExpanded.push(node.id);
    let reversed = node.parentList ? [...node.parentList] : [];
    reversed.forEach(
      function(parentId) {
        let parentNodes = this.state.nodeLookup.filter(
          (ele) => ele.id === parentId
        );
        if (parentNodes.length > 0) {
          newExpanded.push(parentNodes[0].id);
        }
      }.bind(this)
    );
    this.setState({ expanded: newExpanded });
  };

  onSuggestionSelected = (event, suggestion) => {
    if (!suggestion) {
      return;
    }

    this.addToExpanded(suggestion.node);

    if (this.props.multiSelect) {
      if (
        this.getSelectedNodePos(this.state.activeNode, suggestion.node) === -1
      ) {
        this.onClickNode(suggestion.node, event);
        // this.addToExpanded(suggestion.node);
      }
    } else {
      let newSelections = this.state.activeNode.slice();
      if (
        this.getSelectedNodePos(this.state.activeNode, suggestion.node) === -1
      ) {
        newSelections.push(suggestion.node);
        this.setState({ activeNode: newSelections });
        this.props.onNodeSelected(suggestion.node);
      }
    }
  };
  renderSuggestion = (suggestion, query) => {
    const { classes } = this.props;
    const matches = match(suggestion.label, query.inputValue);
    const parts = parse(suggestion.label, matches);

    return (
      <MenuItem selected={query.selected} component="div">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className={classes.labelRoot}>
            <svg height="24px" width="24px">
              <path
                fill={
                  suggestion.node.type === "taxonomy"
                    ? this.state.taxonomyColourTheme
                    : suggestion.node.type === "topic"
                      ? this.state.topicColourTheme
                      : this.state.teamColourTheme
                }
                d={
                  suggestion.node.type === "taxonomy"
                    ? taxonomySVG
                    : suggestion.node.type === "topic"
                      ? topicSVG
                      : teamSVG
                }
              />
            </svg>
          </div>
          {parts.map(
            (part, index) =>
              part.highlight ? (
                <span
                  key={String(index)}
                  style={{ fontWeight: 500 }}
                  dangerouslySetInnerHTML={{
                    __html: part.text.replace(" ", "&nbsp;"),
                  }}
                />
              ) : (
                <strong
                  key={String(index)}
                  style={{ fontWeight: 300 }}
                  dangerouslySetInnerHTML={{
                    __html: part.text.replace(" ", "&nbsp;"),
                  }}
                />
              )
          )}
        </div>
      </MenuItem>
    );
  };

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    let results =
      inputLength === 0
        ? []
        : this.props.taxonomySuggestions.filter((suggestion) => {
            const keep =
              count < 5 && suggestion.label.toLowerCase().includes(inputValue);
            if (
              (this.props.topicSelector && suggestion.node.type !== "topic") ||
              (this.props.allowedSelections &&
                this.props.allowedSelections.indexOf(suggestion.node.type) ===
                  -1)
            ) {
              return false;
            }
            if (keep) {
              count += 1;
            }

            return keep;
          });

    this.setState({ suggestions: results });
  };

  renderInputComponent = (inputProps) => {
    const { classes, inputRef = () => {}, ref, ...other } = inputProps;
    return (
      <TextField
        fullWidth
        label={this.getPlaceHolder}
        {...other}
      />
    );
  };

  getSuggestionValue = (suggestion) => {
    return suggestion.label;
  };

  handleSuggestionsFetchRequested = (value) => {
    this.getSuggestions(value);
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  handeInputChange = (_e, newValue) => {
    if (_e && _e.type === "change") {
      this.setState({
        input: newValue,
      });
      this.handleSuggestionsFetchRequested(newValue);
    }
  };
  handleCloseSnack = () => {
    this.setState({ showNoneSelected: false });
  };
  getPlaceHolder = () => {
    let placeHolder = "Search for a node...";
    if (this.props.allowedSelections) {
      if (this.props.allowedSelections.length == 1) {
        switch (this.props.allowedSelections[0].toLowerCase()) {
          case "topic":
            placeHolder = "Search for a Topic...";
            break;
          case "team":
            placeHolder = "Search for a Team...";
            break;
          case "taxonomy":
            placeHolder = "Search for a Taxonomy...";
            break;
          default:
            placeHolder = "Search...";
            break;
        }
      }
    } else if (this.props.topicSelector) {
      placeHolder = "Search for a topic...";
    }
    return placeHolder;
  };
  applyBadges = (tree) => {
    return this.props.badges && this.props.badges.length > 0
      ? this.mapBadgesToNodes(tree)
      : tree;
  };
  mapBadgesToNodes = (node) => {
    node.badge = this.getBadgeForNode(node);
    node.children &&
      node.children.map((child) => {
        this.mapBadgesToNodes(child);
      });
    return node;
  };
  render() {
    const { classes, t } = this.props;
    return (
      <div style={{ height: "100%" }}>
        <Paper
          className={classes.paper}
          elevation={this.props.noElevate ? 0 : 1}
        >
          {this.props.teamLayoutEditMode === true &&
            this.state.needToCheckIfTeamsCanSee && (
              <Alert severity="info">{t("limited_taxonomy_available")}</Alert>
            )}
          {this.state.needToCheckIfTeamsCanSee &&
            (this.state.taxNodesTeamsCanSee &&
              this.state.taxNodesTeamsCanSee.length < 0) && (
              <Alert severity="error">{t("no_taxonomy_available")}</Alert>
            )}
          {!this.state.canSeeAllTopicSelections && (
            <Alert severity="warning">{t("previous_taxonomy_removed")}</Alert>
          )}
          <Autocomplete
            aria-label="prolly"
            ariaLabel="prolly"
            getOptionLabel={(option) => {
              return option.label;
            }}
            disablePortal
            disabled={this.props.disabled}
            handleHomeEndKeys
            style={{ marginLeft: 8, marginRight: 8 }}
            //  fullWidth
            openOnFocus
            options={this.state.suggestions}
            onChange={this.onSuggestionSelected}
            getOptionSelected={(op, val) => {
              return op.label === val.label;
            }}
            renderOption={this.renderSuggestion}
            inputValue={this.state.input}
            onInputChange={this.handeInputChange}
            renderInput={this.renderInputComponent}
          />

          <div className={classes.treeContainer}>
            {this.state.loading ? (
              this.renderSkeletons()
            ) : this.props.treeType === expertTree &&
            !this.state.expertTreeData.children ? (
              <Alert
                style={{
                  height: "calc(100% - 130px)",
                  backgroundColor: "white",
                }}
                severity="info"
              >
                <AlertTitle>
                  <Trans i18nKey="global_info" />
                </AlertTitle>
                <Trans i18nKey="no_expert_tree_available" />
              </Alert>
            ) : (
              <TreeView
                onNodeSelect={this.treeNodeSelect}
                selected={this.state.selected}
                expanded={this.state.expanded}
                onNodeToggle={this.handleToggle}
                defaultExpanded={[this.props.taxonomyTree.id]}
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                defaultEndIcon={<div style={{ width: 24 }} />}
                children={this.renderNode(
                  this.applyBadges(
                    this.props.treeType === expertTree
                      ? this.state.expertTreeData
                      : this.props.treeType === reportsTree
                        ? this.state.reportsTreeData
                        : this.props.taxonomyTree
                  )
                )}
                classes={{ root: classes.treeRoot }}
              />
            )}
          </div>
        </Paper>
        <Snackbar
          open={this.state.showNoneSelected}
          autoHideDuration={6000}
          onClose={this.handleCloseSnack}
        >
          <SnackbarContent
            className={classes.error}
            action={
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleCloseSnack}
              >
                <CloseIcon />
              </IconButton>
            }
            message={"Error: unselecting this item would leave no selections"}
          />
        </Snackbar>
      </div>
    );
  }
  treeNodeSelect = (event, nodeIds) => {
    this.setState({ selected: nodeIds });
  };
}

const mapStateToProps = (state) => ({
  message: state.websocket.message,
  taxonomyTree: state.taxonomy.taxonomyTree,
  taxonomySuggestions: state.taxonomy.taxonomySuggestions,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
  portalLayout: state.layout.currentLayout,
  teamLayoutEditMode: state.layout.teamLayoutEditMode,
});

export default connect(
  mapStateToProps,
  null
)(withTheme(withStyles(styles)(withTranslation()(TaxonomyTree))));
